import React, { createContext, useContext } from 'react';
import { I18nextProvider, Translation } from 'react-i18next';
import { i18nInit } from '../../i18n';
const TranslationContext = createContext(undefined);
export function TranslationProvider(props) {
    const { children, locale, experiments, baseUrl } = props;
    const i18n = props.i18n ?? i18nInit({ locale, experiments, baseUrl });
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(Translation, null, (t) => (React.createElement(TranslationContext.Provider, { value: t }, children)))));
}
export function useTranslation() {
    const context = useContext(TranslationContext);
    if (!context) {
        throw new Error('useTranslation should be used inside a TranslationProvider');
    }
    return context;
}
//# sourceMappingURL=use-translation.js.map